// © Microsoft Corporation. All rights reserved.

import { backgroundColor } from "@microsoft/fast-components-styles-msft";
import { enums } from "../../utils/enums";
import { reset } from "../../utils/commonJssConstants";

export const ProfilePageStyles = {
    profilePageContainer: {
        ...reset,
        display: "flex",
        "flex-direction": "row",
        "align-items": "flex-start",
        "justify-content": "stretch",
        "min-width": "360px",
        background: backgroundColor,

        "& .cwt-profile-tabs-container": {
            margin: "3px 27px 56px",
            flex: "1",
            "max-width": "960px"
        },

        /* RESPONSIVE CLASSES */
        ["&." + enums.responsiveLevels.L0]: {
            "flex-direction": "column",
            "align-items": "stretch",

            "& .cwt-profile-tabs-container": {
                margin: "9px 3px 56px",
                "max-width": "100%"
            }
        }
    }
};